<style>
    .vs-card--content {
        margin-bottom: 0;
    }
    .disabledlist { 
        color: #bdc3c7
    }
    .disabledText{
        user-select: none;
    }
</style>

<template>
    <div>
        <div class="vx-col w-full mb-base">
            <!-- <vs-card class="p-4">
                <div class="flex items-center">
                    <vs-button radius color="primary" icon="keyboard_backspace" @click="back"></vs-button>
                    <h4 style="margin-left: 10px">Checking and Packing</h4>
                </div>
                <div class="flex items-center">
                    <vs-dropdown vs-trigger-click>
                        <vs-button class="btn mb-4 md:mb-0 mr-1" icon="settings_applications">Process</vs-button>
                        <vs-dropdown-menu>
                            <vs-dropdown-item @click="finishPacking"> Finish Packing </vs-dropdown-item>
                            <vs-dropdown-item @click="cancelPacking"> Cancel Packing </vs-dropdown-item>
                        </vs-dropdown-menu>
                    </vs-dropdown>
                    <vs-dropdown vs-trigger-click>
                        <vs-button class="btn mb-4 md:mb-0 mr-1" icon="print">Print</vs-button>
                        <vs-dropdown-menu>
                            <vs-dropdown-item @click="printPackingList"> Packing List </vs-dropdown-item>
                            <vs-dropdown-item @click="printPackingLabel"> Packing Label </vs-dropdown-item>
                        </vs-dropdown-menu>
                    </vs-dropdown>
                </div>
            </vs-card> -->
            <vs-card class="p-4">
                <vs-alert active="true" icon-pack="feather" icon="icon-alert-circle" class="mb-5">
                    {{ alert }}
                </vs-alert>
                <vs-tabs :value="tab_value">
                    <vs-tab label="Product">
                        <div class="vx-row mb-3 mt-5">
                            <div class="vx-col lg:w-1/4 w-full">
                                <div class="vx-row mb-3">
                                    <div class="vx-col w-1/3">
                                        Product ID*
                                    </div>
                                    <div class="vx-col w-2/3">
                                        <vx-input-group>
                                            <vs-input
                                                v-model="scan.product_code"
                                                :disabled="state != 'product'" @keyup.enter="scanProduct"
                                                ref="product"
                                                @paste.prevent
                                            />
                                            <template slot="append">
                                                <div class="append-text btn-addon">
                                                    <vs-button
                                                        size="small"
                                                        color="primary"
                                                        icon-pack="feather"
                                                        icon="icon-search"
                                                        :disabled="state != 'product'"
                                                    ></vs-button>
                                                </div>
                                            </template>
                                        </vx-input-group>
                                    </div>
                                </div>
                                <div class="vx-row mb-3">
                                    <div class="vx-col w-1/3">
                                        Stock Type
                                    </div>
                                    <div class="vx-col w-2/3">
                                        <vx-input-group>
                                            <vs-input
                                                v-model="scan.stock_type"
                                                :disabled="state != 'product'" @keyup.enter="scanProduct"
                                            />
                                            <template slot="append">
                                                <div class="append-text btn-addon">
                                                    <vs-button
                                                        size="small"
                                                        color="primary"
                                                        icon-pack="feather"
                                                        icon="icon-search"
                                                        :disabled="state != 'product'"
                                                    ></vs-button>
                                                </div>
                                            </template>
                                        </vx-input-group>
                                    </div>
                                </div>
                            </div>
                            <div class="vx-col lg:w-1/4 w-full">
                                <div class="vx-row mb-3">
                                    <div class="vx-col w-1/3">
                                        Multiplier
                                    </div>
                                    <div class="vx-col w-2/3">
                                        <vs-input class="w-full" v-model="scan.multiplier" :disabled="state != 'product'" @keyup.enter="scanProduct"/>
                                    </div>
                                </div>
                                <div class="vx-row mb-3">
                                    <div class="vx-col w-1/3">
                                        UoM
                                    </div>
                                    <div class="vx-col w-2/3">
                                        <vx-input-group>
                                            <vs-input
                                                v-model="scan.uom"
                                                :disabled="state != 'product'" @keyup.enter="scanProduct"
                                            />
                                            <template slot="append">
                                                <div class="append-text btn-addon">
                                                    <vs-button
                                                        size="small"
                                                        color="primary"
                                                        icon-pack="feather"
                                                        icon="icon-search"
                                                        :disabled="state != 'product'"
                                                    ></vs-button>
                                                </div>
                                            </template>
                                        </vx-input-group>
                                    </div>
                                </div>
                            </div>
                            <div class="vx-col lg:w-1/4 w-full">
                                <div class="vx-row mb-3">
                                    <div class="vx-col w-1/3">
                                        Pack ID
                                    </div>
                                    <div class="vx-col w-2/3">
                                        <vs-input class="w-full" v-model="scan.pack_id" :disabled="state != 'product'" @keyup.enter="scanProduct"/>
                                    </div>
                                </div>
                                <div class="vx-row mb-3">
                                    <div class="vx-col w-1/3">
                                        Batch
                                    </div>
                                    <div class="vx-col w-2/3">
                                        <vs-input class="w-full" v-model="scan.batch" :disabled="state != 'product'" @keyup.enter="scanProduct"/>
                                    </div>
                                </div>
                                <div class="vx-row mb-3">
                                    <div class="vx-col w-1/3">
                                        Expired Date
                                    </div>
                                    <div class="vx-col w-2/3">
                                        <flat-pickr class="w-full" v-model="scan.expired_date" :disabled="state != 'product'" @keyup.enter="scanProduct"/>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </vs-tab>
                    <vs-tab label="Packaging">
                        <div class="vx-row mb-3 mt-5">
                            <div class="vx-col lg:w-1/4 w-full">
                                <div class="vx-row mb-3 mt-5">
                                    <div class="vx-col w-1/3">
                                        Packing ID
                                    </div>
                                    <div class="vx-col w-2/3">
                                        <vs-input class="w-full" v-model="packing.packing_id" :disabled="state != 'packing'"/>
                                    </div>
                                </div>
                                <div class="vx-row mb-3 mt-5">
                                    <div class="vx-col w-1/3">
                                        Packaging Type*
                                    </div>
                                    <div class="vx-col w-2/3">
                                        <vs-input class="w-full" v-model="packing.packing_code" ref="packing" :disabled="state != 'packing'" @keyup.enter="scanPacking"/>
                                    </div>
                                </div>
                            </div>
                            <div class="vx-col lg:w-1/4 w-full">
                                <div class="vx-row mb-3 mt-5">
                                    <div class="vx-col w-1/3">
                                        Length
                                    </div>
                                    <div class="vx-col w-2/3">
                                        <vs-input class="w-full" v-model="packing.length" :disabled="state != 'packing'" @keyup.enter="scanPacking"/>
                                    </div>
                                </div>
                                <div class="vx-row mb-3 mt-5">
                                    <div class="vx-col w-1/3">
                                        Width
                                    </div>
                                    <div class="vx-col w-2/3">
                                        <vs-input class="w-full" v-model="packing.width" :disabled="state != 'packing'" @keyup.enter="scanPacking"/>
                                    </div>
                                </div>
                                <div class="vx-row mb-3 mt-5">
                                    <div class="vx-col w-1/3">
                                        Height
                                    </div>
                                    <div class="vx-col w-2/3">
                                        <vs-input class="w-full" v-model="packing.height" :disabled="state != 'packing'" @keyup.enter="scanPacking"/>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </vs-tab>
                </vs-tabs>
                <div v-show="show == 'multiple'" class="mt-5">
                    <h4>{{ title }}</h4>
                    <vs-collapse type="margin" class="p-0">
                        <vs-collapse-item v-for="(detail, index) in data.details" :key="index">
                            <div slot="header" v-bind:class="{ disabledlist: detail.finished}">
                                {{ (detail.tracking_reference ? '#' + detail.tracking_reference : '') + ' - ' + detail.reference  + ' (' + detail.checked + '/' + detail.total + ')'}}
                            </div>
                            <vs-list v-for="(item, itemindex) in detail.items" :key="itemindex">
                                <vs-list-item v-bind:class="{disabledText}" :title="item.product_code + ' (' + item.checked +  '/' + item.total + ')'" :subtitle="item.description"></vs-list-item>
                            </vs-list>
                        </vs-collapse-item>
                    </vs-collapse>
                </div>
                <div v-show="show == 'single'" class="mt-5">
                    <h4>{{ title }}</h4>
                    <vs-collapse type="margin" class="p-0">
                        <vs-collapse-item v-for="(detail, index) in single_detail" :key="index" :open="true">
                            <div slot="header" v-bind:class="{ disabledlist: detail.finished}">
                                {{ 'Reference - ' + detail.reference  + ' (' + detail.checked + '/' + detail.total + ')'}}
                            </div>
                            <vs-list v-for="(item, itemindex) in detail.items" :key="itemindex">
                                <vs-list-item v-bind:class="{disabledText}" :title="item.product_code + ' (' + item.checked +  '/' + item.total + ')'" :subtitle="item.description"></vs-list-item>
                            </vs-list>
                        </vs-collapse-item>
                    </vs-collapse>
                </div>
            </vs-card>
        </div>
    </div>
</template>

<script>
	import vSelect from 'vue-select'
	import flatPickr from 'vue-flatpickr-component';
    import 'flatpickr/dist/flatpickr.css';

	export default {
		components:{
			vSelect,
			flatPickr,
		},
		data(){
			return {
                isLoading: false,
                data: {
                    movement_id: '',
                    container_id: '',
                    details: []
                },
                scan: {
                    multiplier: 1,
                    product_code: '',
                    uom: this.$store.state.user.userconfig.base_uom.name,
                    pack_id: '',
                    batch: '',
                    expired_date: '',
                    stock_type: this.$store.state.user.userconfig.stock_type.name
                },
                packing: {
                    packing_code: '',
                    packing_id: 1,
                    length: 0,
                    width: 0,
                    height: 0
                },
                state: 'container',
                title: 'asd',
                show: '',
                alert: 'Scan container ID',
                tab_value: 0,
                stockTypes: [],
                do_data: {},
                single_detail: []
			}
        },
        watch: {
            isLoading: function(){
                if(this.isLoading){
                    this.$vs.loading()
                }
                else{
                    this.$vs.loading.close()
                }
            }
        },
        methods:{
            back() {
                this.$router.push({
                    name: 'wave-pick-planning-view',
                    params: {
                        id: this.$route.params.id
                    }
                })
            },
            fetchData() {
                this.isLoading = true
                this.$http.post('outbound/check/getlist', {movement_order_id: this.$route.params.id})
                .then(res => {
                    this.title = 'Picklist Number (' + res.data.type + ' SKU) - #' + res.data.id
                    this.data.details = res.data.details
                    this.show = 'multiple'
                    this.state = 'product'
                    this.alert = 'Scan product ID'
                    this.data.movement_id = res.data.id
                    this.focusInput('product')
                })
                .catch(error => {
                    const message = error.response.data.message ? error.response.data.message : 'Something went wrong.'
                    this.$vs.notify({
                        color: 'danger',
                        title: 'Error',
                        iconPack: 'feather',
                        icon:'icon-x',
                        text: message
                    })
                })
                .then(() => this.isLoading = false)
            },
            scanProduct() {
                let error = false
                const data = {
                    movement_id: this.data.movement_id,
                    pack_id: this.scan.pack_id == '' ? null : this.scan.pack_id,
                    batch: this.scan.batch == '' ? null : this.scan.batch,
                    expired_date: this.scan.expired_date == '' ? null : this.scan.expired_date,
                    product_code: this.scan.product_code,
                    uom: this.scan.uom,
                    stock_type: this.scan.stock_type,
                    multiplier: this.scan.multiplier
                }

                if(this.do_data) {
                    data.do_id = this.do_data.do_id
                }
                
                if(!this.scan.stock_type) {
                    error = true
                    this.$vs.notify({
                        color: 'danger',
                        title: 'Error',
                        iconPack: 'feather',
                        icon:'icon-x',
                        text: 'Stock type is required.'
                    })
                }

                if(this.scan.multiplier < 1) {
                    error = true
                    this.$vs.notify({
                        color: 'danger',
                        title: 'Error',
                        iconPack: 'feather',
                        icon:'icon-x',
                        text: 'Multipier cannot be lower than 1.'
                    })
                }

                if(!this.scan.product_code) {
                    error = true
                    this.$vs.notify({
                        color: 'danger',
                        title: 'Error',
                        iconPack: 'feather',
                        icon:'icon-x',
                        text: 'Product code is required.'
                    })
                }

                if(!this.scan.uom) {
                    error = true
                    this.$vs.notify({
                        color: 'danger',
                        title: 'Error',
                        iconPack: 'feather',
                        icon:'icon-x',
                        text: 'UoM is required.'
                    })
                }

                if(error) {
                    return false
                }

                this.isLoading = true
                this.$http.post('outbound/check/searchorder', data)
                .then(res => {
                    this.do_data = res.data
                    if(this.single_detail.length < 1) {
                        this.data.details.map(detail => {
                            if(detail.id == res.data.do_id) {
                                this.single_detail.push(detail)
                            }
                        })
                    }

                    this.show = 'single'
                    this.state = 'packing'
                    this.alert = 'Scan packaging ID'
                    this.tab_value = 1
                    this.focusInput('packing')
                })
                .catch(error => {
                    const message = error.response.data.message ? error.response.data.message : 'Something went wrong'
                    this.isLoading = false
                    this.$vs.notify({
                        color: 'danger',
                        title: 'Error',
                        iconPack: 'feather',
                        icon:'icon-x',
                        text: message
                    })
                })
                .then(() => this.isLoading = false)
            },
            scanPacking() {
                let error = false
                let finished = false
                const data = {
                    do_id: this.do_data.do_id,
                    do_detail_id: this.do_data.do_detail_id,
                    multiplier: this.do_data.multiplier,
                    pack_id: this.do_data.pack_id,
                    batch: this.do_data.batch,
                    expired_date: this.do_data.expired_date,
                    stock_type_id: this.do_data.stock_type_id,
                    uom_id: this.do_data.uom_id,
                    check_base_qty: this.do_data.check_base_qty,
                    packing_code: this.packing.packing_code,
                    width: this.packing.width,
                    length: this.packing.length,
                    height: this.packing.height,
                    packing_id: this.packing.packing_id,
                    movement_id: this.data.movement_id
                }

                if(!this.packing.packing_code) {
                    error = true
                    this.$vs.notify({
                        color: 'danger',
                        title: 'Error',
                        iconPack: 'feather',
                        icon:'icon-x',
                        text: 'Packing type is required.'
                    })
                }

                if(error) {
                    return false
                }

                this.isLoading = true
                this.$http.post('outbound/check/searchpacking', data)
                .then(res => {
                    this.packing.packing_code = ''
                    this.data.details = res.data.details

                    this.data.details.map(detail => {
                        if(detail.id == this.single_detail[0].id) {
                            this.single_detail = []
                            this.single_detail.push(detail)
                        }
                    })

                    this.state = 'product'
                    this.alert = 'Scan product ID'
                    this.tab_value = 1
                    this.focusInput('product')

                    if(this.single_detail[0].finished) {
                        this.single_detail = []
                        this.do_data = {}
                        this.show = 'multiple'
                        finished = true
                    }

                    if(res.data.should_auto_print) {
                        this.printLabel(data.do_id)
                    }
                    
                })
                .catch(error => {
                    const message = error.response.data.message ? error.response.data.message : 'Something went wrong'
                    this.isLoading = false
                    this.$vs.notify({
                        color: 'danger',
                        title: 'Error',
                        iconPack: 'feather',
                        icon:'icon-x',
                        text: message
                    })
                })
                .then(() => this.isLoading = false)
            },
            focusInput(refName) {
                setTimeout(() => {
                    this.$refs[refName].$el.children[0].children[0].focus()
                }, 100);
            },
            printLabel(id) {
                this.isLoading = true
                this.$http.post('outbound/deliveryorder/check/print_packing_label', {id: id}, { responseType: 'blob' })
                .then(response => {
                    this.isLoading = false
                    var blob = new Blob([response.data], {
                        type: 'application/pdf'
                    })
                    window.open(URL.createObjectURL(blob))
                })
                .catch(error => {
                    var reader = new FileReader()
                    const globalThis = this
                    reader.onload = function() {
                        globalThis.isLoading = false
                        const object = JSON.parse(reader.result)
                        const message = object.message ? object.message : 'Something went wrong'

                        globalThis.$vs.notify({
                            color: 'danger',
                            title: 'Error',
                            iconPack: 'feather',
                            icon:'icon-x',
                            text: message
                        })
                    }
                    reader.readAsText(error.response.data)
                })
            }
        },
        mounted(){
            this.fetchData()
        },
	}
</script>